import {
  VIEW_ORDER,
  FAILED_TO_FETCH_CARTS,
  FETCHING_CART_FOR_BILLING,
  PAY_STATUS,
  PARTNER_CONFIRMED_CHECKOUT_DETAILS,
  SET_CHECKOUT_HEADER_MESSAGE,
  SET_CHECKOUT_DETAIL_CONFIRMED,
  SET_PAYMENT_STATUS,
  IS_NOT_DELIVERABLE,
  IS_DELIVERABLE,
  SET_USER_PAYMENT_DETAILS,
  LOGOUT,
} from "../types/types"
const initialState = {
  cartDetailsPartner1: {},
  cartDetailsPartner2: {},
  isLoading: false,
  payStatus: null,
  partnerConfirmedCheckoutDetails: null,
  checkoutHeaderMessage: null,
  confirmedCheckoutDetail: null,
  paymentStatus: null,
  isAddressDeliverable: true,
  paymentDetails: {},
}

export default function (state = initialState, action) {
  const { type, payload } = action
  switch (type) {
    case VIEW_ORDER:
      return {
        ...state,
        cartDetailsPartner1: payload.cart_details_partner1,
        cartDetailsPartner2: payload.cart_details_partner2,
      }
    case FAILED_TO_FETCH_CARTS:
      return initialState
    case FETCHING_CART_FOR_BILLING:
      return {
        ...state,
        isLoading: payload.isLoading,
      }
    case PAY_STATUS:
      return {
        ...state,
        payStatus: payload,
      }
    case PARTNER_CONFIRMED_CHECKOUT_DETAILS:
      return {
        ...state,
        partnerConfirmedCheckoutDetails: payload,
      }
    case SET_CHECKOUT_HEADER_MESSAGE:
      return {
        ...state,
        checkoutHeaderMessage: payload,
      }
    case SET_CHECKOUT_DETAIL_CONFIRMED:
      return {
        ...state,
        confirmedCheckoutDetail: payload,
      }
    case SET_PAYMENT_STATUS:
      return {
        ...state,
        paymentStatus: payload,
      }
    case IS_NOT_DELIVERABLE:
      return {
        ...state,
        isAddressDeliverable: false,
      }
    case IS_DELIVERABLE:
      return {
        ...state,
        isAddressDeliverable: true,
      }
    case SET_USER_PAYMENT_DETAILS:
      return {
        ...state,
        paymentDetails: payload,
      }
    case LOGOUT:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
